export function duplicateRuleName(name: string, existingNames: string[]) {
  const prefix = 'Copy of';
  let newName = `${prefix} ${name}`;
  let counter = 1;

  while (existingNames.includes(newName)) {
    newName = `${prefix} ${name} (${counter})`;
    counter++;
  }

  return newName;
}
